import { absolutePath } from "./absolutePath";

interface CommunityBotFnProps {
  id?: string | number;
  params?: Record<string, unknown>;
}

interface CommunityBotActiveCheckParams {
  ids: number[] | string[];
}

interface ResourceProgressParams extends Record<string, unknown> {
  communityBotProfileId?: number;
  snippetIds: number[];
  spaceIds: number[];
}

const emptyArgs = {
  params: {},
};

export const communityBot = {
  communityResources: {
    index: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath("community_bot/community_resources", params),
  },
  customResources: {
    index: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath("community_bot/custom_resources", params),
  },
  resources: {
    progress: ({ params }: { params: ResourceProgressParams }) => {
      const progressParams: Record<string, unknown> = {
        space_ids: params.spaceIds,
        snippet_ids: params.snippetIds,
      };

      if (typeof params.communityBotProfileId === "number") {
        progressParams.community_bot_profile_id = params.communityBotProfileId;
      }

      return absolutePath(`community_bot/resources/progress`, progressParams);
    },
  },
  sitePages: {
    index: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath("community_bot/site_pages", params),
  },
  snippets: {
    index: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath("community_bot/snippets", params),
    show: ({ id }: CommunityBotFnProps = {}) =>
      absolutePath(`community_bot/snippets/${id}`),
    showPreview: ({ id }: CommunityBotFnProps = {}) =>
      absolutePath(`community_bot/snippets/${id}/preview`),
    create: ({ params }: CommunityBotFnProps = emptyArgs) =>
      absolutePath(`community_bot/snippets`, params),
    createFromFiles: ({ params }: CommunityBotFnProps = emptyArgs) =>
      absolutePath(`community_bot/snippets/create_from_files`, params),
    update: ({ id }: CommunityBotFnProps = {}) =>
      absolutePath(`community_bot/snippets/${id}`),
    destroy: ({ id }: CommunityBotFnProps = {}) =>
      absolutePath(`community_bot/snippets/${id}`),
    bulkDestroy: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath(`community_bot/snippets/bulk_destroy`, params),
  },
  agents: {
    index: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath("community_bot/profiles", params),
    search: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath("community_bot/profiles/search", params),
    show: ({ id }: CommunityBotFnProps = {}) =>
      absolutePath(`community_bot/profiles/${id}`),
    create: () => absolutePath(`community_bot/profiles`),
    update: ({ id }: CommunityBotFnProps = {}) =>
      absolutePath(`community_bot/profiles/${id}`),
    comments: ({ id, params = {} }: CommunityBotFnProps = {}) =>
      absolutePath(`community_bot/profiles/${id}/comments`, params),
    audienceCount: ({ params = {} } = {}) =>
      absolutePath("community_bot/profiles/audience_count", params),
    indexForSearch: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath("search/community_bot/profiles/index_for_search", params),
    indexForConversations: () =>
      absolutePath("search/community_bot/profiles/index_for_conversations"),
    indexForDirectMessages: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath("search/community_bot/profiles", params),
    activeCheck: ({ ids = [] }: CommunityBotActiveCheckParams) =>
      absolutePath("community_bot/profiles/active_check", { ids }),
  },
  spaces: {
    index: ({ params = {} }: CommunityBotFnProps = {}) =>
      absolutePath("community_bot/spaces", params),
    update: ({ id }: CommunityBotFnProps = {}) =>
      absolutePath(`community_bot/spaces/${id}`),
  },
  setting: {
    show: () => absolutePath("community_bot/setting"),
    update: () => absolutePath("community_bot/setting"),
  },
};
